
import React, { useState, useEffect, useContext } from "react";
import useForm from "../../../services/UseForm";
import validate from '../../../validations/admin/product/UploadMenuIconSchema';
import {storage} from '../../../firebase';
import axios from "axios";
import { API } from "../../../services/api";
import '../../../css/UploadImg.css';
import ProgressBar from "../../../components/ProgressBar";
import { ProgressBarContext } from "../../../App";
import "bootstrap/dist/css/bootstrap.min.css";
import {UserContext } from "../../../App";

axios.defaults.baseURL = API;

function UploadIconMenu() {
    const {userID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
    const [image , setImage] = useState(null);
    const [MenuID, setMenuID] = useState(null);
    const {setShowProgressBar, setProgress} = useContext(ProgressBarContext);
    const [imagePreview, setImagePreview] = useState(null);
    const [MenuList, setMenuList] = useState([]);
    const [Url, setUrl] = useState(null);

    const handleSelectProductType = (e) => {
        const { value } = e.target;
        const results = MenuList.filter((data) => {
            return data.ProductType.toLowerCase() === value.toLowerCase()
        });
        if (results.length > 0){
            console.log(results[0].MenuID);
            handleChange("MenuID", results[0].MenuID);
        } else {
            handleChange("MenuID","");
        }
    };

     async function getMenu() {
        axios
        .get("/getmenu")
        .then((response) => {
            let Data = response?.data;
            setMenuList(Data);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setImage(event.target.files[0]);
            handleChange("Image", event.target.files[0].name);
            const objectUrl = URL.createObjectURL(file);
            setImagePreview(objectUrl);
            console.log();
        } else {
            setImage(null);
            handleChange("Image", "");
        }
    };

    const upload = ()=>{
      if(image){
          setShowProgressBar(true);
          const uploadTask = storage.ref(`/images/icon/${image.name}`).put(image);
          uploadTask.on("state_changed", 
          snapshot => {
              const progress = Math.round(
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              setProgress(progress);
          },
          error => {
              console.log(error);
          },
          () => {
              storage.ref("images/icon")
              .child(image.name)
              .getDownloadURL()
              .then(url => {
                 setShowProgressBar(false);
                 setUrl(url);
                 UpdateProductImgUrl(url);
              })
          }
          )
      }
  }

    const UpdateProductImgUrl = async (url) => {
        try {
            let token = localStorage.getItem("token");
            var data = {
                ImgUrl: url,
            }
            await axios.put(`/UploadMenuIcon/${values.MenuID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            }).catch((err) => {
                console.log(err);
            });
        } catch (error) {
            console.error('API Error:', error);
        } 
    };

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(upload, validate);

    const handleclickBack = () => {
        setShowForm(false);
        setshowSubmenu(true);
    };
  
  useEffect(() => {
    getMenu();
  }, []);

  return (
    
    <div className="uploadimgform">
      <ProgressBar bgcolor="orange" progress='0'  height={30} />
          <div className="MainUploadContent">
            <div className="Header">
                <div className="title">
                    <span>Upload Product Image</span>
                </div>
            </div>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="bodyheader">
                        <div className="barcode">
                            <div className="txtSearchProduct">
                                <div className="form-group">
                                    <label>ເມນູ: </label>
                                        <select name="MenuID" onChange={(e) => handleSelectProductType(e)}
                                            className={`input form-control ${errors.MenuID && 'is-invalid'}`}>
                                            <option
                                                key={""}
                                                value={""}
                                            >
                                                {'ເລືອກປະເພດສິນຄ້າ'}
                                            </option>
                                            {   MenuList && MenuList.map(item => (
                                                <option
                                                    key={item.MenuID}
                                                    value={item.ProductType}
                                                >
                                                    {item.ProductType}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                            </div>
                            <div className="btnContent">
                                <button type="submit" className="btn btn-primary">Upload</button>
                                <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
                            </div>  
                        </div>
                        <div className="upload-img">
                            <input type="file" accept="image/*" className={`input form-control ${errors.Image && 'is-invalid'}`} onChange={(event)=> handleImageChange(event)}/>
                            <div className="product-img">
                               {imagePreview && (
                                    <img 
                                        src={imagePreview} 
                                        alt="Selected Preview" 
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </form> 
        </div>
    </div>
  );
};

export default UploadIconMenu;
